import React, { useCallback } from "react";
import { Text } from "../typography";
import {
  MessageBanner,
  MessageBannerType,
} from "@amzn/stencil-react-components/message-banner";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import {
  Button,
  ButtonSize,
  ButtonVariant,
} from "@amzn/stencil-react-components/button";
import { I9ButtonState } from "./i9-data";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import useArb from "../../hooks/use-arb";

interface I9CaasProps {
  loading?: boolean;
  errorMessage?: React.ReactNode;
  message?: any;
  buttonState?: I9ButtonState;
  secureURL?: string;
  allowRetry?: boolean;
  onRetry?: () => void;
  onSubmit?: () => void;
}

export const I9Caas = ({
  loading,
  errorMessage,
  message,
  buttonState: i9ButtonState,
  secureURL,
  allowRetry,
  onRetry,
  onSubmit,
}: I9CaasProps) => {
  const redirect = useCallback(() => {
    if (!secureURL) {
      return;
    }
    onSubmit?.();
    window.location.assign(secureURL);
  }, [secureURL, onSubmit]);

  const bundle = useArb("HVHChecklistPantherResource");

  const loadingText = bundle.getMessage("Checklist-MainPage-I9-loading");
  const buttonText = bundle.getMessage("Checklist-MainPage-I9-ButtonText");
  const retry = bundle.getMessage("Checklist-General-RetryButtonText");

  if (loading) {
    return (
      <Spinner
        size={SpinnerSize.Small}
        loadingText={bundle.getMessage(loadingText)}
        showText={true}
      ></Spinner>
    );
  }

  const shouldShowErrorMessage = !!errorMessage;
  const isButtonDisabled = i9ButtonState === I9ButtonState.Disabled;
  const shouldShowButton =
    !shouldShowErrorMessage && i9ButtonState !== I9ButtonState.Hidden;

  return (
    <Col gridGap="1rem">
      {message && <Text>{message}</Text>}
      {shouldShowErrorMessage && (
        <Col gridGap="1rem">
          <MessageBanner type={MessageBannerType.Error}>
            {errorMessage}
          </MessageBanner>
          {allowRetry && (
            <Row>
              <Button size={ButtonSize.Small} onClick={onRetry}>
                {retry}
              </Button>
            </Row>
          )}
        </Col>
      )}
      {shouldShowButton && (
        <Row gridGap="1rem">
          <Button
            size={ButtonSize.Small}
            variant={ButtonVariant.Primary}
            onClick={redirect}
            disabled={isButtonDisabled}
          >
            {buttonText}
          </Button>
        </Row>
      )}
    </Col>
  );
};
